import { plan } from "venuescanner-js/schemas/serviceSchema.json";
import subDetails from "venuescanner-js/constants/subscription_details";

/** @class
 * @name Plan
 * @desc Class definition of a Subscription Plan - schema defined in venuescanner-js/schemas/serviceSchema.json
 * @param {Object} [values={}] - The values to apply to the model
 */
class Plan {
  constructor(values = {}) {
    Object.keys(plan).forEach((key) => {
      this[key] = values[key];
    });
    if (this.tag && subDetails[this.tag.toUpperCase()]) {
      const consume = subDetails[this.tag.toUpperCase()];
      Object.keys(consume).forEach((key) => {
        this[key] = consume[key];
      });
    }
    Object.defineProperty(this, "price", {
      get() {
        return this.price_month || this.price_year;
      },
    });
  }

  /** @method
   * @name comparisons
   * @memberof Plan
   * @desc Returns the comparison display according to the constants file in venuescanner-js/constants/subscription_details.js
   * @returns {Object[]}
   */
  comparisons() {
    const { display } = subDetails;
    return display.map((title) => {
      return { title, ...(this.comparison[title] || {}) };
    });
  }

  /** @method
   * @name isMonthly
   * @memberof Plan
   * @desc Checks if this Plan has a Monthly payment cycle
   * @returns {Boolean}
   */
  isMonthly(isItMonthly = true) {
    return !!this.price_month === isItMonthly;
  }
}

export default Plan;
